import { PROMISE_CALL } from "fredux";
import apiForm from "application/api/api-form";
import apiAnswers from "application/api/api-answers";

export const SEARCH_FORM = "SEARCH_FORM";
export const CREATE_ANSWER = "CREATE_ANSWER";

export const searchForm = (id) => ({
  type: SEARCH_FORM,
  [PROMISE_CALL]: () => apiForm.searchForm(id),
});

export const createAnswer = (content) => ({
  type: CREATE_ANSWER,
  [PROMISE_CALL]: () => apiAnswers.createAnswer(content),
});
